import React from 'react';
import Draggable from 'react-draggable';

class Frame extends React.Component {
	render() {
		const { details, isSelected, onClick } = this.props;
		return (
			<Draggable grid={[10,10]}>
		  	<div className={`frame ${isSelected && 'selected'}`} style={details} onClick={onClick} />
			</Draggable>
		);
	}
}

export default Frame;
